import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {ErrorFabricService} from 'app/core/error-handler/error-fabric.service';
import {ErrorNotifierService} from 'app/core/error-handler/error-notifier.service';
import {AuthorizationError} from 'app/core/error-handler/errors/authorization.error';
import {REDIRECT_TO_LEGACY_LOGIN} from 'app/core/helpers/redirect';
import {Observable, throwError} from 'rxjs';
import {catchError, switchMap, tap} from 'rxjs/operators';
import {environment} from 'src/environments/environment';
import {AuthService} from 'app/core/services/auth.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(
        private auth: AuthService,
        private errorService: ErrorNotifierService,
        private errorFabric: ErrorFabricService,
        @Inject(REDIRECT_TO_LEGACY_LOGIN) public redirectToHome: () => void
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const url = request.url;
        request = request.clone({
            setHeaders: {
                // server return 401 error code instead of redirecting to login page if we send this header
                'x-requested-with': `XMLHttpRequest`,
            },
        });
        return next.handle(request).pipe(
            catchError((networkError: HttpErrorResponse) => {
                let error = this.errorFabric.create(networkError);
                if (error instanceof AuthorizationError) {
                    return this.auth.signOut().pipe(
                        tap(() => this.redirectToHome()),
                        switchMap(() => throwError(error))
                    );
                }
                // rethrow original error
                // it's supposed to be handled by apollo service which provide addition error details
                if (url.includes(environment.graphQlEndpoint)) {
                    return throwError(networkError);
                }
                if (error.isCritical()) {
                    this.errorService.notifyBugTracker(error);
                }
                return throwError(error);
            })
        );
    }
}
